import React, { useState, useEffect } from "react";
import "./App.css";
import { Link, useHistory, Redirect } from "react-router-dom";
import Axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import ResendCode from "./components/resend/ResendCode";
// import Footer from "./components/Footer";
// import Header from "./components/Header";

const Verification = (props) => {
  const history = useHistory();
  const [verification, setVerification] = useState("");
  const [error, setError] = useState("");
  const [errorDisplay, setErrorDisplay] = useState("none");
  const [spinning, setSpinning] = useState("none");
  const [updateDisplay, setUpdateDisplay] = useState("block");
  const [accountVerified, setAccountVerified] = useState(false);
  const [showBox, setShowBox] = useState("error-login");

  const email = props.location.state?.email;
  const password = props.location.state?.password;
  const account_type = props.location.state?.accounttype;

  useEffect(() => {
    document.title = "Verifying account - Karamale";
  }, []);

  const handleVerify = (event) => {
    setVerification(event.target.value);
    setErrorDisplay("none");
  };

  const verify = () => {
    setUpdateDisplay("none");
    setSpinning("block");

    const affiliate_id = localStorage.getItem("affiliateid") ?? null;

    if (verification.trim() === "") {
      setError("Enter the verification code");
      setErrorDisplay("block");
      setUpdateDisplay("block");
      setSpinning("none");
      setShowBox("error-login");
      setTimeout(() => {
        setErrorDisplay("none");
      }, 5000);
      return;
    }

    const baseURL = "https://karamale.com/apps/kscanner/webservices.php";
    const data = new FormData();
    data.append("email", email);
    data.append("password", password);
    data.append("verificationCode", verification);
    data.append("account_type", account_type);
    data.append("affiliate_id", affiliate_id);
    data.append("query", "REGISTRATION");

    Axios.post(baseURL, data, { withCredentials: true })
      .then((response) => {
        if (response.data.status === "success") {
          localStorage.removeItem("affiliateid");
          setAccountVerified(true);
        } else {
          setError(response.data.message);
          setShowBox("error-login");
          setErrorDisplay("block");
          setSpinning("none");
          setUpdateDisplay("block");
        }

        setTimeout(() => {
          setErrorDisplay("none");
        }, 5000);
      })
      .catch((error) => console.log(error));
  };

  if (!localStorage.getItem("verificationAccount")) {
    return <Redirect to="/register" />;
  }

  return (
    <div className="view">
      {/* <Header /> */}
      <div className="container">
        <div className="row justify-content-center align-content-center login-screen-container w-100">
          <div className="col-lg-5 col-12 align-self-center login-container-adjust">
            <div className="log-title login-logo text-center">
              <Link to="/">
                <img
                  src="https://karamale.com/karamale.png"
                  alt="Karamale Logo"
                />
              </Link>
            </div>
            <div className="col-12 pl-0 pr-0">
              {accountVerified ? (
                <div className="card">
                  <h2>
                    ✅ <br />
                    Account Verified
                  </h2>
                  <p>
                    Your account is verified and ready to go. Click below to log
                    in and get started.
                  </p>
                  <p>
                    <a href="https://karamale.com/login">Proceed to log in</a>
                  </p>
                </div>
              ) : (
                <div className="BoxDashboardContainer">
                  <input
                    type="text"
                    placeholder="Enter verification code"
                    value={verification}
                    onChange={handleVerify}
                  />
                  <div className="col-12 response textMedium pl-0">
                    {/* You can add response messaging here if needed */}
                  </div>
                  <button
                    onClick={verify}
                    className={`${
                      spinning === "block"
                        ? "btn-disabled text-bold"
                        : "save-btn"
                    } w-100`}
                    disabled={spinning === "block"}
                  >
                    <span style={{ display: updateDisplay }}>Verify</span>
                    <span style={{ display: spinning }}>
                      <ClipLoader color={"grey"} loading={true} size={20} />
                    </span>
                  </button>
                </div>
              )}
            </div>

            {!accountVerified && (
              <div className="text-footer text-center">
                We've sent the <span>verification code</span> to
                <br /> {email}
                <br />
                <label className="mt-2">
                  <ResendCode
                    email={email}
                    onResend={(email) => {
                      console.log("Preparing to send request...");
                      const data = new FormData();
                      data.append("email", email);
                      data.append("query", "RESEND_VERIFICATION_CODE");

                      return Axios.post(
                        "https://karamale.com/apps/kscanner/webservices.php",
                        data,
                        {
                          withCredentials: true,
                        }
                      )
                        .then((res) => {
                          if (res.data.status === "success") {
                            setError(res.data.message);
                            setErrorDisplay("block");
                            setUpdateDisplay("block");
                            setSpinning("none");
                            setShowBox("success-login");
                          } else {
                            setError(res.data.message);
                            setErrorDisplay("block");
                            setUpdateDisplay("block");
                            setSpinning("none");
                            setShowBox("error-login");
                          }

                          setTimeout(() => {
                            setErrorDisplay("none");
                          }, 5000);
                        })
                        .catch((err) => {
                          console.error("Axios error:", err);
                        });
                    }}
                  />
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={showBox}
        style={{ display: errorDisplay, textAlign: "center" }}
      >
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Verification;
